import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';

export default function Help() {
  const { t: translate } = useTranslation();

  return (
    <Link to="/help" className="btn app-bar-tools-btn app-bar-help">
      <span className="btn-icon">
        <Icons.Help />
      </span>
      <span className="btn-text">{translate(resources.menu.help)}</span>
    </Link>
  );
}
